'use client';

import {
  Box,
  Drawer,
  DrawerBody,
  Flex,
  type FlexProps,
  freddyTheme,
  Link
} from '@coolblue-development/freddy';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { type ReactNode, useContext, useState } from 'react';

import { FilterPageContext } from '../../context';

export default function IntroductionTextWrapper({
  title,
  children,
  ...rest
}: {
  title: string;
  children: ReactNode;
} & FlexProps) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(() => false);
  const collapseTranslations = useFreddyTranslations('collapse');
  const drawerTranslations = useFreddyTranslations('drawer');
  const { isPending } = useContext(FilterPageContext);

  return (
    <Flex
      sx={{
        opacity: isPending ? 0.2 : 1,
        [freddyTheme.breakpoint.maxWidth('md')]: {
          p: {
            height: freddyTheme.typography.lineHeight[500],
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          }
        }
      }}
      {...rest}
    >
      {children}
      <Link
        component='button'
        hideFrom='md'
        sx={{ whiteSpace: 'nowrap' }}
        onClick={() => setIsDrawerOpen(true)}
      >
        {collapseTranslations.labelCollapsed}
      </Link>
      <Box hideFrom='md'>
        <Drawer
          translations={drawerTranslations}
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          placement='bottom'
          aria-label={title}
          title={title}
          body={<DrawerBody>{children}</DrawerBody>}
        />
      </Box>
    </Flex>
  );
}
